import styled, { css } from "styled-components";
import { Link as RouterLink } from "react-router-dom";

import Icon from "../../../../../../../components/Icon";

export const MenuWrapper = styled.div`
  height: 20px;
  position: relative;
  display: inline-flex;
`;

export const MenuToggle = styled.button`
  height: 20px;
  border-radius: 4px;
  border: none;
  background: white;
  display: inline-flex;
  padding: 0px 6px;
  gap: 6px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
  color: ${({ theme }) => theme.colors.Black};
  font-size: 12px;
  font-weight: 600;

  &:hover,
  &:focus-visible {
    outline: none;
    background: ${({ theme }) => theme.colors.Primary};
    color: white;
  }
`;

export const MenuToggleIcon = styled(Icon) <{ isOpen: boolean }>`
  color: inherit;
  transition: transform 0.2s ease;
  transform: rotate(${({ isOpen }) => (isOpen ? "180deg" : "0deg")});
`;

export const MenuList = styled.ul`
  position: absolute;
  top: calc(100% + 2px);
  right: 0;
  margin: 0;
  list-style: none;
  background: #ffffff;
  box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.16);
  z-index: 30;
  padding: 0;
  overflow: hidden;
  border-radius: 8px;
  max-width: 170px;
  min-width: 130px;
`;

export const MenuListItem = styled.li`
  width: 100%;
`;

const baseMenuItem = css`
  width: 100%;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.8);
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover,
  &:focus-visible {
    outline: none;
    background: ${({ theme }) => theme.colors.Primary};
    color: white;
  }
`;

export const MenuItemButton = styled.button`
  ${baseMenuItem}
`;

export const MenuItemLink = styled(RouterLink)`
  ${baseMenuItem}
`;

export const MenuItemIcon = styled(Icon)`
  color: inherit;
`;
